module.exports = __webpack_public_path__ + "img/kid-a-blue.2b7a4202.svg";